export default "__VITE_ASSET__2ZEzIIM_atdpHcr$6kvj$Q__"